import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-design-crop-icon',
  templateUrl: './design-crop.component.html'
})
export class DesignCropComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
